import { useMutation } from "@tanstack/react-query";

import { updateOrganizationPrimaryProvider } from "~/admins/api";

export const useUpdateOrganizationPrimaryProvider = () => {
  return useMutation({
    mutationFn: updateOrganizationPrimaryProvider,
  });
};
